/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class IdentifyGroupsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Identify groups
     * @param requestBody The group to identify. Takes a JSON object containing names and values of group properties and traits. If the group does not exist, it creates it with these properties and traits. If it does exist, it sets the properties and traits to these values, overwriting existing values.
     * @param projectId
     * @param xProjectToken
     * @returns any Request accepted
     * @throws ApiError
     */
    public identifyGroupsPost(
        requestBody: {
            /**
             * The unique identifier for this group in your database.
             */
            id: string;
            /**
             * The name of this group as recorded in your database.
             */
            name?: string | null;
            /**
             * The domain associated with this group, often used in business contexts.
             */
            domain?: string;
            /**
             * A dictionary of attributes that provide additional details about the group, such as location, subscription tier, or other relevant metadata.
             */
            traits?: Record<string, any> | null;
            /**
             * The unique IDs of the people in the group, used for linking the group to users for example.
             */
            distinctIds?: Array<string> | null;
        },
        projectId?: string | null,
        xProjectToken?: string | null,
    ): CancelablePromise<{
        message: {
            message: 'Request accepted';
        };
        success: boolean;
        error: any;
        result?: any;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/identify/groups',
            headers: {
                'x-project-token': xProjectToken,
            },
            query: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Delete an identified group
     * @param id
     * @param projectId
     * @param xProjectToken
     * @returns any Request accepted
     * @throws ApiError
     */
    public identifyGroupsDel(
        id: string,
        projectId?: string | null,
        xProjectToken?: string | null,
    ): CancelablePromise<{
        message: {
            message: 'Request accepted';
        };
        success: boolean;
        error: any;
        result?: any;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/identify/groups/{id}',
            path: {
                'id': id,
            },
            headers: {
                'x-project-token': xProjectToken,
            },
            query: {
                'projectId': projectId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Update properties
     * Updates or adds properties or traits to a group. The group is created if it does not exist.
     * @param id
     * @param requestBody The group properties and traits to update. Takes a JSON object containing names and values of group properties and traits. If the group does not exist, it creates it with these properties and traits. If it does exist, it updates the provided properties and traits to these values, overwriting existing values.
     * @param projectId
     * @param xProjectToken
     * @returns any Request accepted
     * @throws ApiError
     */
    public identifyGroupsPatch(
        id: string,
        requestBody: {
            /**
             * The name of this group as recorded in your database.
             */
            name?: string | null;
            /**
             * The domain associated with this group, often used in business contexts.
             */
            domain?: string;
            /**
             * A dictionary of attributes that provide additional details about the group, such as location, subscription tier, or other relevant metadata.
             */
            traits?: Record<string, any> | null;
            /**
             * The unique IDs of the people in the group, used for linking the group to users for example.
             */
            distinctIds?: Array<string> | null;
        },
        projectId?: string | null,
        xProjectToken?: string | null,
    ): CancelablePromise<{
        message: {
            message: 'Request accepted';
        };
        success: boolean;
        error: any;
        result?: any;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/identify/groups/{id}',
            path: {
                'id': id,
            },
            headers: {
                'x-project-token': xProjectToken,
            },
            query: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Removes a person from a group
     * @param groupId
     * @param distinctId
     * @param projectId
     * @param xProjectToken
     * @returns any Successful request
     * @throws ApiError
     */
    public identifyGroupsRemove(
        groupId: string,
        distinctId: string,
        projectId?: string | null,
        xProjectToken?: string | null,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: any;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/identify/groups/{groupId}/{distinctId}',
            path: {
                'groupId': groupId,
                'distinctId': distinctId,
            },
            headers: {
                'x-project-token': xProjectToken,
            },
            query: {
                'projectId': projectId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
}
